export default Backbone.Collection.extend({

	getLastModified: function()
	{
		return _.max( this.map( function( m ) { return m.getLastModified(); } ) );
	},


// 	hasChanged: function()
// 	{
// 		return this.some( function( model ) { return model.hasChanged(); } );
// 	},

	isValid: function()
	{
		return _.every( this.invoke('isValid') );
	},


	update: function( list, options )
	{
		var key = this.model.prototype.idAttribute || 'id';
		var safe = this.model.prototype.safe || [];
// 		var opt = _.extend( { silent: true }, options );

		var json = this.toJSON();
		json = _.object( _.pluck( json, key ), json );
		list = _.object( _.pluck( list, key ), list );


		_.each( list, function( data )
		{
			var id = data[key];

			if( _.has( data, 'deleted_at' ) && data.deleted_at )
			{
				delete json[ id ];
			}
			else if( !_.has( json, id ) )
			{
				json[id] = data;
			}
			else
			{
				var obj = json[id];

				if( !_.has( obj, 'updated_at') || !_.has( data, 'updated_at' ) || !_.has(obj,'todo') || !(data['updated_at'] <= obj['updated_at'] ) )
				{
					json[id] = _.extend( data, _.pick( obj, safe ) );
				}
			}

			// updated_at = toujours la valeur serveur
			if( _.has( data, 'updated_at' ) && _.has( json, id ) )
			{
				json[id].updated_at = data.updated_at;
			}

			// etag = toujours la valeur serveur
			if( _.has( data, 'etag' ) && _.has( json, id ) )
			{
				json[id].etag = data.etag;
			}
		});

		this.reset( _.values( json ), options );

		// If-Modified-Since seulement après la dernière page (évite les trous)
		if( !options || !options.skipModifiedSince )
		{
			app.store.settings.setModifiedSince( this );
		}

		this.trigger( 'update', this, options );
	},


	fetch: function( options )
	{
		options = app.store.settings.addIfModifiedSinceHeader( this, options || {} );

		var collection = this;
		var deferred = $.Deferred();
		var limit = 1000;
		var offset = 0;
		var total = null;

		$('.sync-count').text( '' );

		// Charge page par page jusqu'à épuisement
		var fetchPage = function()
		{
			var pageOptions = _.extend( {}, options, {
				validate: false,
				parse: true,
				skipModifiedSince: true,
				data: _.extend( {}, options.data || {}, { offset: offset, limit: limit } ),
			} );

			collection.sync( 'read', collection, pageOptions )
				.done( function( json, status, jqXHR )
				{
					if( jqXHR && ( jqXHR.status === 204 || jqXHR.status === 304 || status === 'notmodified' ) )
					{
						$('.sync-count').text( '' );
						deferred.resolve();
						return;
					}

					// Progression en pourcentage (total fourni à offset 0)
					if( json && json.total != null )
					{
						total = json.total;
					}
					if( total != null && total > 0 )
					{
						var loaded = offset + ( json && json.data ? json.data.length : 0 );
						var percent = Math.min( 100, Math.round( 100 * loaded / total ) );
						$('.sync-count').text( percent + '%' );
					}

					if( json && json.has_more )
					{
						offset += limit;
						fetchPage();
						return;
					}

					$('.sync-count').text( '' );
					app.store.settings.setModifiedSince( collection );
					deferred.resolve();
				} )
				.fail( function()
				{
					$('.sync-count').text( '' );
					deferred.reject();
				} );
		};

		fetchPage();

		return deferred.promise();
	},


	commit: function()
	{
		var deferred = $.Deferred();
		var collection = this;
		var pending = this.filter( function( m )
		{
			return m.isSavable();
		} );

		var loop = function()
		{
			var object = pending.shift();

			if( !object )
			{
				collection.fetch().always( function()
				{
					deferred.resolve();
				} );
				return;
			}

			var save = ( object.get( 'todo' ) == 'delete' ) ? object.destroy() : object.save();

			if( !save )
			{
				_.defer( loop );
				return;
			}

			save.done( function()
			{
				object.unset( 'todo' );
			} );

			object.set( 'saving', true );
			save.always( function()
			{
				object.unset( 'saving' );
				loop();
			} );
		};

		_.defer( loop );

		return deferred.promise();
	},


	sync: function( method, collection, options )
	{
		var xhr = Backbone.sync( method, collection, options );

		xhr.done( function( json, status, jqXHR )
		{
			if( jqXHR && ( jqXHR.status === 204 || jqXHR.status === 304 || status === 'notmodified' ) )
			{
				console.log( method, collection, 'not modified' );
			}
			else if( status == 'success' && json )
			{
				// Enveloppe paginée { data } ou tableau legacy
				var list = _.isArray( json ) ? json : ( json.data || [] );
				if( !_.isEmpty( list ) )
				{
					collection.update( list, options );
				}
			}

			console.log( method, collection );
			collection.trigger('sync', collection, xhr, options);
			collection.trigger( method );
		})

		xhr.fail( function( xhr, status, name )
		{
			// 401 = utilisateur non connecté
			if( xhr.status == 401 )
			{
				app.signout();
			}

			// Sinon, c'est un problème !
			else
			{
				console.error( status, name, xhr.responseJSON );
			}
		});

// 		deferred.done(function()
// 		{
// 			console.log( method, collection );
// 			collection.trigger('sync', collection, xhr, options);
// 			collection.trigger( method );
// 		});

// 		return deferred;

		return xhr;
	},


	persist: function()
	{
		return app.storage.write( 'data', this.file, JSON.stringify( this.toJSON( this ) ) );
	},

	restore: function()
	{
		return app.storage.read( 'data', this.file ).done( _.bind( function( text )
		{
			try
			{
				this.reset( JSON.parse( text ), { validate: false, parse: true } );
			}
			catch( error )
			{
				console.warn( 'Collection.restore', this, error );
			}
		}, this ));
	},
});
